"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronRightLargeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5.98041685,5.07948289 C5.68752363,4.78658967 5.68752363,4.31171593 5.98041685,4.01882272 C6.27331007,3.7259295 6.74818381,3.7259295 7.04107702,4.01882272 L12.541077,9.51882272 L7.04107702,15.0193023 C6.74818381,15.3121955 6.27331007,15.3121955 5.98041685,15.0193023 C5.68752363,14.7264091 5.68752363,14.2515353 5.98041685,13.9586421 L10.4197567,9.51882272 L5.98041685,5.07948289 Z" })));
};
ChevronRightLargeSmall.displayName = 'ChevronRightLargeSmall';
exports.default = ChevronRightLargeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronRightLargeSmall.js.map